export const loginSuccessfulHtmlResponse = () => {
  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Login Successful</title>
    <style>
      * {
        margin: 0;
        padding: 0;
      }
      body {
        display: flex;
        flex-direction: column;
        height: 100vh;
        background-color: #f3f4f6;
        font-family: Arial, sans-serif;
      }
      .navbar {
        width: 100%;
        background-color: #ffffff;
        padding: 13px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
      }
      .logo {
        height: 24px;
      }
      .container {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .card {
        background-color: #ffffff;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        text-align: center;
        max-width: 320px;
      }
      .icon {
        width: 48px;
        height: 48px;
        margin-bottom: 16px;
        color: #10b981;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #111827;
      }
      .message {
        color: #6b7280;
        margin-top: 8px;
      }

      a {
        outline: none;
        color: inherit;
      }
    </style>
  </head>
  <body>
    <div class="navbar">
      <a href="https://scalar.com" class="logo">
        <svg
          class="flow-icon"
          height="100%"
          viewBox="0 0 593 593"
          xmlns="http://www.w3.org/2000/svg"
          data-v-477980d2=""
        >
          <path
            d="M347 0c6 0 12 5 12 12v134l94-95c5-5 13-5 17 0l72 72c4 4 5 12 0 16v1l-95 94h134c7 0 12 5 12 12v101c0 7-5 12-12 12H447l95 94c4 5 5 13 0 17l-72 72c-4 4-12 5-16 0h-1l-94-95v134c0 7-5 12-12 12H246c-7 0-12-5-12-12v-70c0-22 9-43 24-59l130-130c14-14 14-37 0-51L259 142a84 84 0 0 1-25-59V12c0-7 5-12 12-12zM138 52h1l219 219c14 14 14 37 0 51L139 542c-4 5-12 5-17 0l-71-70c-4-5-5-12 0-17l95-96H12c-7 0-12-5-12-12V246c0-7 5-12 12-12h134l-95-94c-4-5-4-12 0-17l71-71c4-5 12-5 16 0"
            fill="currentColor"
            fill-rule="evenodd"
            data-v-477980d2=""
          ></path>
        </svg>
      </a>
    </div>
    <div class="container">
      <div class="card">
        <svg
          class="icon"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M5 13l4 4L19 7"
          ></path>
        </svg>
        <h1 class="title">Login Successful</h1>
        <p class="message">
          You have successfully logged in. You may now close this window.
        </p>
      </div>
    </div>
  </body>
</html>
`
}
